import React from "react"
import { Row, Col } from "react-bootstrap"
import ExhibitionCard from "../../components/ExhibitionCard"
import Container from "../../components/Layout/Container"
import { HeadingTitle } from "../../components/Layout/HeadingTitle"
import Wrapper from "../../components/Layout/Wrapper"
import { useExhibitionsActions } from "../../actions/useExhibitionsActions"
import { SearchSortHeader } from "../../components/Layout/SearchSortHeader"
import { SeoTags } from "../../components/Layout/SeoTags"
import { HelmetTitle } from "../../components/Layout/HelmetTitle"
import { Loader } from "../../components/Layout/Loader"
import ExhibitionCardBigButton from "../../components/ExhibitionCardBigButton"
import { imageResizer } from "../../../services/utils/imageResizer"

const ExhibitionsPage = ({ exhibitions }) => {
  const {
    exhibitions: paginatedExhibitions,
    setSearch,
    loading,
    sort,
    setSort,
    sorts,
    loadingMore,
  } = useExhibitionsActions(exhibitions)

  const Elements = () => {
    if (loading) {
      return <Loader />
    }

    return (
      <Row>
        {paginatedExhibitions.data.map(
          ({ id, description, image, thumbnail, date, title, author }) => (
            <Col xs={12} md={6} lg={3} key={id}>
              <ExhibitionCard
                id={id}
                image={imageResizer(thumbnail ?? image, 600, `AUTO`)}
                title={title}
                date={date}
                author={author}
                to={`/exhibitions/${id}`}
                href={"/exhibitions/[id]"}
              />
              {/* <ExhibitionCardBigButton
                id={id}
                image={image}
                name={title}
                author={author}
                date={date}
                to={`/exhibitions/${id}`}
                href={"/exhibitions/[id]"}
                cta="Visit"
              /> */}
            </Col>
          ),
        )}
      </Row>
    )
  }

  return (
    <Wrapper>
      <SeoTags
        title="Exhibition | Discover ArtPlacer"
        description="Enjoy online art shows. Visualize art pieces in a virtual exhibition."
        url="https://discover.artplacer.com/spaces"
        canonical="https://discover.artplacer.com/spaces"
      />
      <HelmetTitle title="Exhibition" />
      <Container>
        <div className="pb-3">
          <HeadingTitle title="Virtual Exhibitions">
            Visualize art pieces and collections in 3D online exhibitions.
          </HeadingTitle>
        </div>
        <SearchSortHeader
          onChangeInput={(val) => setSearch(val)}
          title=""
          hideSearch={false}
          searchPlaceholder="Search Virtual Exhibitions"
          sorts={sorts}
          sort={sort}
          setSort={setSort}
        />
        {paginatedExhibitions.total > 0 ? (
          <Elements />
        ) : (
          <p className="noResults">No results match your search.</p>
        )}
        {loadingMore && <Loader />}
      </Container>
    </Wrapper>
  )
}

export default ExhibitionsPage
